module.exports = __webpack_public_path__ + "static/img/irole.de41d9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/yzzzbq/irole.png
// module id = iA4p
// module chunks = 7